import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { EXPLORE_PROGRAMS } from "@/data/homeContent";
import { INDUSTRIES, industryPath } from "@/data/industries";
const ROW = "flex min-h-[44px] items-center py-2 font-semibold text-ink border-b-2 border-brand-50";
const SUB_LINK = "block py-2 text-ink hover:text-brand-600";

export function MobileMenu({ open, onOpenChat }) {
  if (!open) return null;

  return (
    <div
      className="lg:hidden max-h-[calc(100vh-4rem)] overflow-y-auto bg-white border-t-2 border-brand-100 px-4 pt-3 pb-6 space-y-1"
      data-testid="mobile-menu"
    >
      <Link to="/about" className={ROW}>
        About Us
      </Link>

      <div className="py-2 border-b-2 border-brand-50">
        <div className="font-bold text-ink mb-2 flex items-center justify-between">
          <span>Explore</span>
          <span className="text-xs bg-brand-100 text-brand-700 px-2.5 py-0.5 rounded-full font-bold">New Cohorts</span>
        </div>
        <div className="pl-3 space-y-4 text-sm">
          <div>
            <p className="text-[11px] font-bold uppercase tracking-wider text-brand-600 mb-1">Industries</p>
            <ul className="space-y-0.5">
              {INDUSTRIES.map((industry) => (
                <li key={industry.id}>
                  <Link to={industryPath(industry.id)} className={SUB_LINK}>
                    <span className="font-semibold">{industry.name}</span>
                    <span className="block text-xs text-ink/70">{industry.tagline}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-[11px] font-bold uppercase tracking-wider text-brand-600 mb-1">Programs</p>
            <ul className="space-y-0.5">
              {EXPLORE_PROGRAMS.map((item) => (
                <li key={item.title}>
                  <Link to={item.to} className={SUB_LINK}>
                    <span className="font-semibold">{item.title}</span>
                    <span className="block text-xs text-ink/70">{item.tagline}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <Link to="/contact" className={ROW}>
        Contact
      </Link>

      <div className="pt-4 flex flex-col gap-2">
        <button
          type="button"
          onClick={onOpenChat}
          className="w-full min-h-[44px] bg-brand-50 text-ink font-semibold py-2.5 rounded-full text-center flex items-center justify-center gap-2 border border-brand-200"
        >
          <MessageCircle className="w-4 h-4 text-brand-500" aria-hidden="true" />
          Quick Chat
        </button>
        <Link
          to="/consultation"
          className="w-full min-h-[44px] bg-sun-500 text-ink font-bold py-3 rounded-lg text-center block"
        >
          Book Free Consultation
        </Link>
      </div>
    </div>
  );
}
